import { connect } from 'react-redux';

import BookingSectionButton from './BookingSectionButton';
import mapDispatchToProps from './mapDispatchToProps';

const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BookingSectionButton);
